var _g, _path, _path2, _path3, _g2, _path4, _g3, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 696,
    height: 300,
    viewBox: "0 0 696 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_31)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_183_31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 75,
    width: 166,
    height: 166,
    rx: 30,
    fill: "#171918"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 76,
    width: 164,
    height: 164,
    rx: 29,
    stroke: "#C8C8C8",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.361 131.118L145.064 132.192C143.532 137.393 131.898 186.738 130.957 190.729C130.742 191.335 129.317 195.16 126.684 195.16C122.331 195.16 120.37 188.638 120.37 188.611C119.671 186.105 117.118 184.674 114.674 185.39C112.228 186.105 110.831 188.72 111.529 191.225C112.927 196.178 117.709 204.6 126.712 204.6C134.505 204.6 138.642 197.527 139.824 193.344C139.852 193.261 139.878 193.178 139.878 193.123C144.205 174.766 152.696 138.96 153.878 134.916L154.201 133.788C155.142 130.485 158.016 120.44 161.752 120.44C165.03 120.44 165.596 126.192 165.596 126.33C165.811 128.916 167.986 130.843 170.541 130.65C173.066 130.458 174.974 128.173 174.787 125.586C174.41 120.55 171.186 111 161.754 111C151.111 111 147.241 124.594 145.361 131.118Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.262 131.118L130.965 132.192C129.433 137.393 117.798 186.738 116.857 190.729C116.642 191.335 115.218 195.16 112.585 195.16C108.231 195.16 106.27 188.638 106.27 188.611C105.571 186.105 103.018 184.674 100.574 185.39C98.1284 186.105 96.7312 188.72 97.4298 191.225C98.827 196.178 103.61 204.6 112.612 204.6C120.405 204.6 124.543 197.527 125.725 193.344C125.752 193.261 125.779 193.178 125.779 193.123C130.105 174.766 138.596 138.96 139.779 134.916L140.101 133.788C141.042 130.485 143.916 120.44 147.653 120.44C150.931 120.44 151.496 126.192 151.496 126.33C151.711 128.916 153.886 130.843 156.441 130.65C158.967 130.458 160.875 128.173 160.687 125.586C160.31 120.55 157.086 111 147.655 111C137.012 111 133.142 124.594 131.262 131.118Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.012 131.118L116.715 132.192C115.183 137.393 103.548 186.738 102.607 190.729C102.392 191.335 100.968 195.16 98.3347 195.16C93.981 195.16 92.0201 188.638 92.0201 188.611C91.3215 186.105 88.7685 184.674 86.3239 185.39C83.8784 186.105 82.4812 188.72 83.1798 191.225C84.577 196.178 89.3596 204.6 98.362 204.6C106.155 204.6 110.293 197.527 111.475 193.344C111.502 193.261 111.529 193.178 111.529 193.123C115.855 174.766 124.346 138.96 125.529 134.916L125.851 133.788C126.792 130.485 129.666 120.44 133.403 120.44C136.681 120.44 137.246 126.192 137.246 126.33C137.461 128.916 139.636 130.843 142.191 130.65C144.717 130.458 146.625 128.173 146.437 125.586C146.06 120.55 142.836 111 133.405 111C122.762 111 118.892 124.594 117.012 131.118Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_183_31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 75,
    width: 166,
    height: 166,
    rx: 30,
    fill: "#EC602F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 76,
    width: 164,
    height: 164,
    rx: 29,
    stroke: "#C8C8C8",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_183_31",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 298,
    y: 108,
    width: 100,
    height: 100
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.72 207.441C375.18 207.441 397.441 185.18 397.441 157.72C397.441 130.261 375.18 108 347.72 108C320.261 108 298 130.261 298 157.72C298 185.18 320.261 207.441 347.72 207.441Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_183_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.842 160.562C328.301 160.562 350.562 138.301 350.562 110.841C350.562 83.3813 328.301 61.1207 300.842 61.1207C273.382 61.1207 251.121 83.3813 251.121 110.841C251.121 138.301 273.382 160.562 300.842 160.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.842 254.32C328.301 254.32 350.562 232.06 350.562 204.6C350.562 177.14 328.301 154.879 300.842 154.879C273.382 154.879 251.121 177.14 251.121 204.6C251.121 232.06 273.382 254.32 300.842 254.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.599 160.562C422.059 160.562 444.32 138.301 444.32 110.841C444.32 83.3813 422.059 61.1207 394.599 61.1207C367.14 61.1207 344.879 83.3813 344.879 110.841C344.879 138.301 367.14 160.562 394.599 160.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.599 254.32C422.059 254.32 444.32 232.06 444.32 204.6C444.32 177.14 422.059 154.879 394.599 154.879C367.14 154.879 344.879 177.14 344.879 204.6C344.879 232.06 367.14 254.32 394.599 254.32Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_183_31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 75,
    width: 166,
    height: 166,
    rx: 30,
    fill: "url(#paint0_linear_183_31)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 76,
    width: 164,
    height: 164,
    rx: 29,
    stroke: "#C8C8C8",
    strokeWidth: 2
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M590.622 186.615L590.619 186.618C588.709 188.528 585.543 188.528 583.633 186.618L573.54 176.525L585.733 164.332C586.913 163.153 587.309 161.324 586.649 159.741C585.994 158.168 584.43 157.125 582.726 157.125H561.526C560.63 157.125 559.794 156.568 559.449 155.741C559.109 154.924 559.313 153.953 559.933 153.332L583.633 129.632C585.543 127.723 588.709 127.723 590.619 129.632L615.719 154.732C617.628 156.641 617.628 159.807 615.72 161.717C615.72 161.717 615.719 161.718 615.719 161.718L590.622 186.615Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M558.518 151.818C558.517 151.819 558.516 151.82 558.515 151.821C557.338 153.001 556.943 154.828 557.602 156.41C558.257 157.982 559.821 159.025 561.525 159.025H582.725C583.621 159.025 584.457 159.582 584.802 160.41C585.142 161.227 584.938 162.198 584.318 162.818L560.518 186.618C558.608 188.527 555.442 188.527 553.532 186.618L528.432 161.518C526.523 159.608 526.523 156.442 528.432 154.532L553.532 129.432C555.442 127.523 558.608 127.523 560.518 129.432L570.616 139.53L558.518 151.818Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122 75V69.9408C122 53.3722 108.569 39.9408 92 39.9408H30C13.4315 39.9408 0 26.5093 0 9.94079V2",
    stroke: "white",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348 75L348 2",
    stroke: "#EC602F",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348 303L348 241",
    stroke: "#EC602F",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126 241V241C126 257.155 112.903 270.252 96.7479 270.252H35.7479C19.3186 270.252 6 283.571 6 300V300",
    stroke: "white",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M571.5 75.5V69C571.5 52.4315 584.931 39 601.5 39H663C679.569 39 693 25.5685 693 9V-0.5",
    stroke: "#4D66F4",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M567 241V241C567 257.155 580.097 270.252 596.252 270.252H657.252C673.681 270.252 687 283.571 687 300V300",
    stroke: "#4D66F4",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_183_31",
    x: 26,
    y: 57,
    width: 206,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_183_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_183_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_183_31",
    x: 245,
    y: 57,
    width: 206,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.376471 0 0 0 0 0.184314 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_183_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_183_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_183_31",
    x: 464,
    y: 57,
    width: 206,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.243137 0 0 0 0 0.231373 0 0 0 0 0.843137 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_183_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_183_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_183_31",
    x1: 487,
    y1: 152.5,
    x2: 650,
    y2: 160.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ED7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#4E69F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A30CF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 696,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup);
export default __webpack_public_path__ + "static/media/startup.12d23738709b04e26b1b87d10164ff45.svg";
export { ForwardRef as ReactComponent };